import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import * as VseSession from '../../features/session';

export function LoginControl() {
  const sessionState = VseSession.useVseSessionState();
  const dispatch = useDispatch();
  const location = useLocation();
  const isInLoginPage = location.pathname === "/login";
  const loggedIn = sessionState.token.isAuthenticated && sessionState.loading !== 'timeout';
  const loginButton = <Button component={Link} variant="outlined" color="inherit" to='/login'>Login</Button>;
  const logoutButton = <Button component={Link} variant="outlined" color="inherit" to='/logout'>Logout</Button>;

  React.useEffect(() => {
    if (sessionState.loading === 'idle') {
      dispatch(VseSession.challenge());
    }
  }, [dispatch, sessionState.loading]);

  return (
    loggedIn ? logoutButton : isInLoginPage ? <div /> : loginButton
  );
}
